import React from 'react'
import create from 'zustand'
import createContext from 'zustand/context'
import shallow from 'zustand/shallow'

const { Provider, useStore } = createContext()

const createStore = () => {
  return create((set) => {
    const setBindTbId = (bindTbId) => {
      set(() => ({ bindTbId }))
    }
    const setCurrentField = (currentField) => {
      set(() => ({ currentField }))
    }

    const setIsCalStandards = (isCalStandards) => {
      set(() => ({ isCalStandards }))
    }

    return {
      bindTbId: null,
      currentField: null,
      isCalStandards: false,
      setBindTbId,
      setCurrentField,
      setIsCalStandards,
    }
  })
}

const BindProvider = function ({ children }) {
  return (
    <Provider
      createStore={() => {
        return createStore()
      }}
    >
      {children}
    </Provider>
  )
}

const useBindStore = (selectors, equalityFn = shallow) =>
  useStore(selectors, equalityFn)

export { BindProvider, useBindStore }
